export default "__VITE_ASSET__3a9b6bb6__"